const Layout = () => import("@/views/layout/Index.vue");
//需确认路由
const guide = () => import("../views/guide.vue");
const PANDAEDI = () => import("../views/EDI.vue");
const defend = () => import("../views/defend.vue");
const help = () => import("../views/help.vue");
const homepage = () => import("../views/homepage.vue");
const accountOpenList = () => import("../views/accountOpenMange/accountList.vue");
const accountDetail = () => import("../views/accountOpenMange/accountDetail.vue");
const accountApplyTwitter = () => import("../views/accountOpenMange/accountApplyTwitter");
const accountApplyGoogle = () => import("../views/accountOpenMange/accountApplyGoogle");
const accountApplyTaboola = () => import("../views/accountOpenMange/accountApplyTaboola");
const accountOpes = () => import("../views/accountOpenMange/accountOpes.vue");
const setGroup = () => import("../views/accountOpenMange/setGroup.vue");
const bmPixelOpes = () => import("../views/accountOpenMange/bmPixelOpes.vue");
const aritReport = () => import("../views/accountOpenMange/aritReport.vue");
const openAccountApply = () => import("../views/accountOpenMange/openAccountApply.vue");

const mediaRechargeApply = () => import("../views/accountOpenMange/mediaRechargeApply.vue");
const accountOpenApplyList = () => import("../views/accountOpenMange/accountOpenApplyList.vue");
const openAccountApplyDetail = () => import("../views/accountOpenMange/openAccountApplyDetail.vue");
const fBOEApplyList = () => import("../views/accountOpenMange/fBOEApplyList.vue");
const fBOEApplySub = () => import("../views/accountOpenMange/fBOEApplySub.vue");
const accountDoApplyList = () => import("../views/accountOpenMange/accountDoApplyList.vue");
const accountDoApplyDetail = () => import("../views/accountOpenMange/accountDoApplyDetail.vue");
const accountDoApplyReSub = () => import("../views/accountOpenMange/accountDoApplyReSub.vue");

const mediaRechargeRecordList = () => import("../views/rechargeManagement/mediaRechargeRecordList.vue");
const grandsList = () => import("../views/rechargeManagement/grandsList.vue");
const grandDetail = () => import("../views/rechargeManagement/grandDetail.vue");
const grandsReplay = () => import("../views/rechargeManagement/grandsReplay.vue");
const mediaCreditRechargeDetail = () => import("../views/rechargeManagement/mediaCreditRechargeDetail.vue");
const accountInfo = () => import("../views/accountManage/accountInfo.vue");
const accountInfoEdit = () => import("../views/accountManage/accountInfoEdit.vue");
const authorizeList = () => import("../views/accountManage/authorizeList.vue");
const accountOpenCompany = () => import("../views/accountManage/accountOpenCompany.vue");
const userList = () => import("../views/userManage/userList.vue");
const userAdd = () => import("../views/userManage/userAdd.vue");
const userEdit = () => import("../views/userManage/userEdit.vue");
const operationLog = () => import("../views/userManage/operation.log.vue");
const reOpenSubmit = () => import("../views/accountOpenMange/reOpenSubmit.vue");
const batchDo = () => import("../views/accountOpenMange/batchDo.vue");
const batchDetail = () => import("../views/accountOpenMange/batchDetail.vue");
const batchReplay = () => import("../views/accountOpenMange/batchReplay.vue");

const walletRechargeRecord = () => import("../views/rechargeManagement/walletRechargeRecord.vue");
const walletRecharge = () => import("../views/rechargeManagement/walletRecharge.vue");

const virtualBankAccount = () => import("../views/rechargeManagement/virtualBankAccount.vue");

const companyInfo = () => import("../views/informations/companyInfo.vue");
const createAccountCompany = () => import("../views/informations/createAccountCompany.vue");

const personalInfo = () => import("../views/informations/personalInfo.vue");
const user = () => import("../views/informations/user.vue");

const createShop = () => import("../views/shop/createShop.vue");

const leafLet = () => import("../views/leafLet.vue");
const billManage = () => import("../views/bill/billManage.vue");
const billDetail = () => import("../views/bill/billDetail.vue");

const statements = () => import("../views/bill/statements.vue");
const statementDetail = () => import("../views/bill/statementDetail.vue");

const analysis = () => import("../views/analysis/analysis.vue");
const singleAccountCompClosedInfo = () => import("../views/analysis/singleAccountCompClosedInfo.vue");
const singleAccountCompTrendAdsInfo = () => import("../views/analysis/singleAccountCompTrendAdsInfo.vue");

const fbClosedCost = () => import("../views/analysis/fbClosedCost.vue");
const trendAdsCost = () => import("../views/analysis/trendAdsCost.vue");
const aiCostLine = () => import("../views/analysis/aiCostLine.vue");

const myReportForms = () => import("../views/reportForms/myReportForms.vue");
const creatReportForms = () => import("../views/reportForms/creatReportForms.vue");

const refundList = () => import("../views/refund/refundList.vue");
const drawback = () => import("../views/refund/drawback.vue");
const refundDetail = () => import("../views/refund/refundDetail.vue");

const changeRecord = () => import("../views/companyWallet/changeRecord.vue");
const serviceRulePage = () => import("../views/accountOpenMange/serviceRulePage.vue");

// fb 预警及建议
const closeAccounts = () => import("../views/fbWarnings/closeAccounts.vue");
const refusedAds = () => import("../views/fbWarnings/refusedAds.vue");
const suggestions = () => import("../views/fbWarnings/suggestions.vue");
const suggestionInfo = () => import("../views/fbWarnings/suggestionDetail.vue");

const feedback = () => import("../views/feedback/index.vue");
const feedbackDetail = () => import("../views/feedback/detail.vue");

const remittanceVoucher = () => import("../views/remittanceVoucher/remittanceVoucher.vue");

const coupon = () => import("../views/metaPage/coupon.vue");

const rechargeSetting = () => import("@/views/accountManage/rechargeSetting.vue");

const act = [
  {
    // 官网
    path: "/",
    name: "index",
    component: leafLet,
    meta: {
      metaInfo: {
        title: "Panda Rocket _ 跨境广告投放管理平台_PandaMobo 熊猫新媒产品",
        keywords: "Meta广告投放，Meta广告推广，Google广告投放，Google广告推广，X广告投放，X广告推广，脸书广告投放，脸书广告推广，谷歌广告投放，谷歌广告推广，推特广告投放，推特广告推广，海外营销，海外广告投放，跨境营销，跨境广告投放，海外广告代理商，Meta广告代理商，Google广告代理商，Twitter广告代理商，脸书广告代理商，谷歌广告代理商，推特广告代理商",
        description: "Panda Rocket 是熊猫新媒（PandaMobo)打造的一款海外广告投放管理工具，隶属于上市公司久其软件。致力于帮助国内用户解决海外媒体投放的问题，您可以在这里完成 Meta、X、Google平台的广告账户申请、广告账户充值、广告投放效果获取等一系列的操作。",
      },
    },
  },
  {
    path: "/guide",
    name: "guide",
    component: guide,
    title: "引导",
  },
  {
    path: "/PANDAEDI",
    name: "PANDAEDI",
    component: PANDAEDI,
    title: "EDI",
  },
  {
    path: "/defend",
    name: "defend",
    component: defend,
    title: "维护",
  },
  {
    path: "/help",
    name: "help",
    component: help,
    title: "帮助",
  },
  {
    path:'/defrayedCallback',
    name: "defendCallback",
    component:()=>import("../views/remittanceVoucher/DefrayedCallback.vue")
  },
  {
    path:'/payoneerAuthCallback',
    name:'payoneerAuthCallback',
    component:()=>import("../views/remittanceVoucher/PayoneerAuthCallback.vue"),
  },
  {
    path: "/layout",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/index",
        name: "homepage",
        component: homepage,
        meta: {
          title: "首页",
          requireAuth: true,
          crumbs: [
            {
              label: "首页",
              to: "/index",
            },
          ],
          nav: 0,
          to: "/index",
        },
      },
      {
        path: "/virtualBankAccount",
        name: "virtualBankAccount",
        component: virtualBankAccount,
        meta: {
          title: "汇款账户",
          requireAuth: true,
          crumbs: [
            {
              label: "汇款账户",
              to: "/virtualBankAccount",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/remittanceVoucher",
        name: "remittanceVoucher",
        component: remittanceVoucher,
        meta: {
          title: "付款记录",
          requireAuth: true,
          crumbs: [
            {
              label: "账户列表",
              to: "/remittanceVoucher",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountList",
        name: "accountList",
        component: accountOpenList,
        meta: {
          title: "账户列表",
          requireAuth: true,
          crumbs: [
            {
              label: "账户列表",
              to: "/accountList",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/rechargeSetting",
        name: "rechargeSetting",
        component: rechargeSetting,
        meta: {
          title: "账户充值设置",
          requireAuth: true,
          crumbs: [
            {
              label: "账户充值设置",
              to: "/rechargeSetting",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/createShop",
        name: "createShop",
        component: createShop,
        meta: {
          title: "建立店铺",
          requireAuth: true,
          crumbs: [
            {
              label: "建立店铺",
              to: "/createShop",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/user",
        name: "user",
        component: user,
        meta: {
          title: "系统用户",
          requireAuth: true,
          crumbs: [
            {
              label: "用户管理",
              to: "/user",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/closeAccounts",
        name: "closeAccounts",
        component: closeAccounts,
        meta: {
          title: "封户账户列表",
          requireAuth: true,
          crumbs: [
            {
              label: "封户账户列表",
              to: "/closeAccounts",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/adOptimization",
        name: "AdOptimization",
        component: () => import("@/views/fbWarnings/AdOptimization.vue"),
        meta: {
          title: "广告优化建议",
          requireAuth: true,
          series:'adOptimization',
          crumbs: [
            {
              label: "广告优化建议",
              to: "/adOptimization",
            },
          ],
        },
      },
      {
        path: "/adOptimizationDetail",
        name: "AdOptimizationDetail",
        component: () => import("@/views/fbWarnings/AdOptimizationDetail.vue"),
        meta: {
          title: "广告优化建议详情",
          requireAuth: true,
          series:'adOptimization',
          crumbs: [
            {
              label: "广告优化建议详情",
              to: "/adOptimizationDetail",
            },
          ],
        },
      },
      {
        path: "/accountEarlyWarning",
        name: "accountEarlyWarning",
        component: () => import("@/views/fbWarnings/accountEarlyWarning.vue"),
        meta: {
          title: "Meta 账户异常消耗",
          requireAuth: true,
          crumbs: [
            {
              label: "Meta 账户异常消耗",
              to: "/accountEarlyWarning",
            },
          ],
        },
      },
      {
        path: "/refusedAds",
        name: "refusedAds",
        component: refusedAds,
        meta: {
          title: "拒登广告列表",
          requireAuth: true,
          crumbs: [
            {
              label: "拒登广告列表",
              to: "/refusedAds",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/suggestionInfo",
        name: "suggestionInfo",
        component: suggestionInfo,
        meta: {
          title: "整改建议详情",
          requireAuth: true,
          crumbs: [
            {
              label: "整改建议",
              to: "/suggestionInfo",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/suggestions",
        name: "suggestions",
        component: suggestions,
        meta: {
          title: "整改建议",
          requireAuth: true,
          crumbs: [
            {
              label: "整改建议",
              to: "/suggestions",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/feedback",
        name: "feedback",
        component: feedback,
        meta: {
          title: "意见反馈",
          requireAuth: true,
          crumbs: [
            {
              label: "意见反馈",
              to: "/feedback",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/feedbackDetail",
        name: "feedbackDetail",
        component: feedbackDetail,
        meta: {
          title: "意见反馈",
          requireAuth: true,
          crumbs: [
            {
              label: "意见反馈",
              to: "/feedbackDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/serviceRulePage",
        name: "serviceRulePage",
        component: serviceRulePage,
        meta: {
          title: "服务费规则",
          requireAuth: true,
          crumbs: [
            {
              label: "服务费规则",
              to: "/serviceRulePage",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountDetail",
        name: "accountDetail",
        component: accountDetail,
        meta: {
          title: "账户列表",
          requireAuth: true,
          crumbs: [
            {
              label: "账户列表",
              to: "/accountDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/singleAccountCompClosedInfo",
        name: "singleAccountCompClosedInfo",
        component: singleAccountCompClosedInfo,
        meta: {
          title: "数据分析",
          requireAuth: true,
          crumbs: [
            {
              label: "数据分析",
              to: "/singleAccountCompClosedInfo",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/singleAccountCompTrendAdsInfo",
        name: "singleAccountCompTrendAdsInfo",
        component: singleAccountCompTrendAdsInfo,
        meta: {
          title: "数据分析",
          requireAuth: true,
          crumbs: [
            {
              label: "数据分析",
              to: "/singleAccountCompTrendAdsInfo",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/analysis",
        name: "analysis",
        component: analysis,
        meta: {
          title: "数据分析",
          requireAuth: true,
          crumbs: [
            {
              label: "数据分析",
              to: "/analysis",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/fbClosedCost",
        name: "fbClosedCost",
        component: fbClosedCost,
        meta: {
          title: "Meta 封户趋势",
          requireAuth: true,
          crumbs: [
            {
              label: "Meta 封户趋势",
              to: "/fbClosedCost",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/trendAdsCost",
        name: "trendAdsCost",
        component: trendAdsCost,
        meta: {
          title: "Meta 拒登广告消耗趋势",
          requireAuth: true,
          crumbs: [
            {
              label: "Meta 拒登广告消耗趋势",
              to: "/trendAdsCost",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/aiCostLine",
        name: "aiCostLine",
        component: aiCostLine,
        meta: {
          title: "AI素材消耗趋势",
          requireAuth: true,
          crumbs: [
            {
              label: "AI素材消耗趋势",
              to: "/trendAdsCost",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountApplyTwitter",
        name: "accountApplyTwitter",
        component: accountApplyTwitter,
        meta: {
          title: "推特广告账户申请",
          requireAuth: true,
          crumbs: [
            {
              label: "推特广告账户申请",
              to: "/accountApplyTwitter",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountApplyTaboola",
        name: "accountApplyTaboola",
        component: accountApplyTaboola,
        meta: {
          title: "Taboola广告账户申请",
          requireAuth: true,
          crumbs: [
            {
              label: "Taboola广告账户申请",
              to: "/accountApplyTaboola",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountApplyGoogle",
        name: "accountApplyGoogle",
        component: accountApplyGoogle,
        meta: {
          title: "谷歌广告账户申请",
          requireAuth: true,
          crumbs: [
            {
              label: "谷歌广告账户申请",
              to: "/accountApplyGoogle",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountApplyTikTok",
        name: "accountApplyTikTok",
        component: ()=>import('../views/accountOpenMange/accountApplyTikTok.vue'),
        meta: {
          title: "TikTok广告账户申请",
          requireAuth: true,
          crumbs: [
            {
              label: "TikTok广告账户申请",
              to: "/accountApplyTikTok",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountOpes",
        name: "accountOpes",
        component: accountOpes,
        meta: {
          title: "账户列表",
          requireAuth: true,
          crumbs: [
            {
              label: "",
              to: "/accountOpes",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/setGroup",
        name: "setGroup",
        component: setGroup,
        meta: {
          title: "",
          requireAuth: true,
          crumbs: [
            {
              label: "",
              to: "/setGroup",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/bmPixelOpes",
        name: "bmPixelOpes",
        component: bmPixelOpes,
        meta: {
          title: "账户列表",
          requireAuth: true,
          crumbs: [
            {
              label: "",
              to: "/bmPixelOpes",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/aritReport",
        name: "aritReport",
        component: aritReport,
        meta: {
          title: "申请开户",
          requireAuth: true,
          crumbs: [
            {
              label: "申请开户",
              to: "/aritReport",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/openAccountApply",
        name: "openAccountApply",
        component: openAccountApply,
        meta: {
          title: "申请开户",
          requireAuth: true,
          crumbs: [
            {
              label: "申请开户",
              to: "/openAccountApply",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountOpenApplyList",
        name: "accountOpenApplyList",
        component: accountOpenApplyList,
        meta: {
          title: "申请记录",
          requireAuth: true,
          crumbs: [
            {
              label: "申请记录",
              to: "/accountOpenApplyList",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/openAccountApplyDetail",
        name: "openAccountApplyDetail",
        component: openAccountApplyDetail,
        meta: {
          title: "开户申请详情",
          requireAuth: true,
          crumbs: [
            {
              label: "申请记录",
              to: "/accountOpenApplyList",
            },
            {
              label: "申请详情",
              to: "/openAccountApplyDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/fBOEApplyList",
        name: "fBOEApplyList",
        component: fBOEApplyList,
        meta: {
          title: "OE开户申请记录",
          requireAuth: true,
          crumbs: [
            {
              label: "OE开户申请记录",
              to: "/fBOEApplyList",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/billManage",
        name: "billManage",
        component: billManage,
        meta: {
          title: "发票",
          requireAuth: true,
          crumbs: [
            {
              label: "OE开户申请记录",
              to: "/billManage",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/billDetail",
        name: "billDetail",
        component: billDetail,
        meta: {
          title: "发票",
          requireAuth: true,
          crumbs: [
            {
              label: "发票详情",
              to: "/billDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/statements",
        name: "statements",
        component: statements,
        meta: {
          title: "对账单",
          requireAuth: true,
          crumbs: [
            {
              label: "对账单",
              to: "/statements",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/refundList",
        name: "refundList",
        component: refundList,
        meta: {
          title: "退款记录",
          requireAuth: true,
          crumbs: [
            {
              label: "退款记录",
              to: "/refundList",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/drawback",
        name: "drawback",
        component: drawback,
        meta: {
          title: "申请退款",
          requireAuth: true,
          crumbs: [
            {
              label: "申请退款",
              to: "/drawback",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/refundDetail",
        name: "refundDetail",
        component: refundDetail,
        meta: {
          title: "退款详情",
          requireAuth: true,
          crumbs: [
            {
              label: "退款详情",
              to: "/refundDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/statementDetail",
        name: "statementDetail",
        component: statementDetail,
        meta: {
          title: "对账单详情",
          requireAuth: true,
          crumbs: [
            {
              label: "对账单详情",
              to: "/statementDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/changeRecord",
        name: "changeRecord",
        component: changeRecord,
        meta: {
          title: "企业钱包",
          requireAuth: true,
          crumbs: [
            {
              label: "企业钱包",
              to: "/changeRecord",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/fBOEApplySub",
        name: "fBOEApplySub",
        component: fBOEApplySub,
        meta: {
          title: "OE提交申请",
          requireAuth: true,
          crumbs: [
            {
              label: "OE提交申请",
              to: "/fBOEApplySub",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountDoApplyList",
        name: "accountDoApplyList",
        component: accountDoApplyList,
        meta: {
          title: "FB账户操作申请记录",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户操作申请记录",
              to: "/accountDoApplyList",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountDoApplyReSub",
        name: "accountDoApplyReSub",
        component: accountDoApplyReSub,
        meta: {
          title: "accountDoApplyReSub",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户操作申请记录",
              to: "/accountDoApplyList",
            },
            {
              label: "重新提交",
              to: "/accountDoApplyReSub",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountDoApplyDetail",
        name: "accountDoApplyDetail",
        component: accountDoApplyDetail,
        meta: {
          title: "accountDoApplyDetail",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户操作申请记录",
              to: "/accountDoApplyList",
            },
            {
              label: "FB账户操作申请详情",
              to: "/accountDoApplyDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/reOpenSubmit",
        name: "reOpenSubmit",
        component: reOpenSubmit,
        meta: {
          title: "重新提交",
          requireAuth: true,
          crumbs: [
            {
              label: "申请记录",
              to: "/accountOpenApplyList",
            },
            {
              label: "重新提交",
              to: "/reOpenSubmit",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/mediaRechargeApply",
        name: "mediaRechargeApply",
        component: mediaRechargeApply,
        meta: {
          title: "媒体平台账号充值申请",
          requireAuth: true,
          crumbs: [
            {
              label: "账户列表",
              to: "/accountList",
            },
            {
              label: "媒体平台账号充值申请",
              to: "/mediaRechargeApply",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/batchDo",
        name: "batchDo",
        component: batchDo,
        meta: {
          title: "批量操作申请记录",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户批量操作申请记录",
              to: "/batchDo",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/batchDetail",
        name: "batchDetail",
        component: batchDetail,
        meta: {
          title: "FB账户批量操作申请记录详情",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户批量操作申请记录",
              to: "/batchDo",
            },
            {
              label: "详情",
              to: "/batchDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/batchReplay",
        name: "batchReplay",
        component: batchReplay,
        meta: {
          title: "重新提交",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户批量操作申请记录",
              to: "/batchDo",
            },
            {
              label: "重新提交",
              to: "/batchReplay",
            },
          ],
          nav: 1,
        },
      },
      {
        //以下是充值记录页面
        path: "/mediaRechargeRecordList",
        name: "mediaRechargeRecordList",
        component: mediaRechargeRecordList,
        meta: {
          title: "充值记录",
          requireAuth: true,
          crumbs: [
            {
              label: "充值记录",
              to: "/mediaRechargeRecordList",
            },
          ],
          nav: 2,
        },
      },
      {
        path: "/mediaCreditRechargeDetail",
        name: "mediaCreditRechargeDetail",
        component: mediaCreditRechargeDetail,
        meta: {
          title: "充值记录详情",
          requireAuth: true,
          crumbs: [
            {
              label: "充值记录",
              to: "/mediaRechargeRecordList",
            },
            {
              label: "充值记录详情",
              to: "/mediaCreditRechargeDetail",
            },
          ],
          nav: 2,
        },
      },
      {
        path: "/grandsList",
        name: "grandsList",
        component: grandsList,
        meta: {
          title: "FB账户拨款申请记录",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户拨款申请记录",
              to: "/grandsList",
            },
          ],
          nav: 2,
        },
      },
      {
        path: "/grandDetail",
        name: "grandDetail",
        component: grandDetail,
        meta: {
          title: "拨款详情",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户拨款申请记录",
              to: "/grandsList",
            },
            {
              label: "拨款详情",
              to: "/grandDetail",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/grandsReplay",
        name: "grandsReplay",
        component: grandsReplay,
        meta: {
          title: "重新提交",
          requireAuth: true,
          crumbs: [
            {
              label: "FB账户拨款申请记录",
              to: "/grandsList",
            },
            {
              label: "重新提交",
              to: "/grandsReplay",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/walletRechargeRecord",
        name: "walletRechargeRecord",
        component: walletRechargeRecord,
        meta: {
          title: "钱包充值记录",
          requireAuth: true,
          crumbs: [
            {
              label: "钱包充值记录",
              to: "/walletRechargeRecord",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/walletRecharge",
        name: "walletRecharge",
        component: walletRecharge,
        meta: {
          title: "钱包充值",
          requireAuth: true,
          crumbs: [
            {
              label: "钱包充值",
              to: "/walletRecharge",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/accountInfo",
        name: "accountInfo",
        component: accountInfo,
        meta: {
          title: "账号信息",
          requireAuth: true,
          crumbs: [
            {
              label: "账号信息",
              to: "/accountInfo",
            },
          ],
          nav: 3,
        },
      },
      {
        path: "/accountInfoEdit",
        name: "accountInfoEdit",
        component: accountInfoEdit,
        meta: {
          title: "编辑信息",
          requireAuth: true,
          crumbs: [
            {
              label: "账号信息",
              to: "/accountInfo",
            },
            {
              label: "编辑信息",
              to: "/accountInfoEdit",
            },
          ],
          nav: 3,
        },
      },
      {
        path: "/authorizeList",
        name: "authorizeList",
        component: authorizeList,
        meta: {
          title: "授权记录列表",
          requireAuth: true,
          crumbs: [
            {
              label: "授权记录列表",
              to: "/authorizeList",
            },
          ],
          nav: 3,
        },
      },
      {
        path: "/accountOpenCompany",
        name: "accountOpenCompany",
        component: accountOpenCompany,
        meta: {
          title: "开户公司",
          requireAuth: true,
          crumbs: [
            {
              label: "开户公司",
              to: "/accountOpenCompany",
            },
          ],
          nav: 3,
        },
      },
      {
        path: "/createAccountCompany",
        name: "createAccountCompany",
        component: createAccountCompany,
        meta: {
          title: "新建开户公司",
          requireAuth: true,
          crumbs: [
            {
              label: "新建开户公司",
              to: "/createAccountCompany",
            },
          ],
          nav: 3,
        },
      },
      {
        //以下是用户管理管理页面
        path: "/userList",
        name: "userList",
        component: userList,
        meta: {
          title: "用户列表",
          requireAuth: true,
          crumbs: [
            {
              label: "用户列表",
              to: "/userList",
            },
          ],
          nav: 3,
        },
      },
      {
        path: "/userAdd",
        name: "userAdd",
        component: userAdd,
        meta: {
          title: "用户列表",
          requireAuth: true,
          crumbs: [
            {
              label: "用户列表",
              to: "/userList",
            },
            {
              label: "新增用户",
              to: "/userAdd",
            },
          ],
          nav: 3,
        },
      },
      {
        path: "/userEdit",
        name: "userEdit",
        component: userEdit,
        meta: {
          title: "用户列表",
          requireAuth: true,
          crumbs: [
            {
              label: "用户列表",
              to: "/userList",
            },
            {
              label: "编辑用户",
              to: "/userEdit",
            },
          ],
          nav: 3,
        },
      },
      {
        path: "/operationLog",
        name: "operationLog",
        component: operationLog,
        meta: {
          title: "操作日志",
          requireAuth: true,
          crumbs: [
            {
              label: "操作日志",
              to: "/operationLog",
            },
          ],
          nav: 3,
        },
      },
      {
        //以下是企业信息页面
        path: "/companyInfo",
        name: "companyInfo",
        component: companyInfo,
        meta: {
          title: "企业信息",
          requireAuth: true,
          crumbs: [
            {
              label: "企业信息",
              to: "/companyInfo",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/personalInfo",
        name: "personalInfo",
        component: personalInfo,
        meta: {
          title: "个人信息",
          requireAuth: true,
          crumbs: [
            {
              label: "个人信息",
              to: "/personalInfo",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/coupon",
        name: "coupon",
        component: coupon,
        meta: {
          title: "领取优惠券",
          requireAuth: true,
          crumbs: [
            {
              label: "领取优惠券",
              to: "/coupon",
            },
          ],
          nav: 1,
        },
      },
      {
        path: "/myReportForms",
        name: "myReportForms",
        component: myReportForms,
      },
      {
        path: "/creatReportForms",
        name: "creatReportForms",
        component: creatReportForms,
      },
      {
        path: "/notices",
        name: "notices",
        component: () => import("@/views/notice/list.vue"),
        meta: {
          title: " 系统通知",
          requireAuth: true,
          crumbs: [
            {
              label: "系统通知",
              to: "/notices",
            },
          ],
          nav: 3,
        },
      },
      {
        path:'/tiktokBC',
        name:'tiktokBC',
        component: ()=>import('@/views/accountOpenMange/TikTokBC.vue'),
        meta:{
          title:'广告账户',
          requireAuth:true,
          crumbs:[
            {
              label:'',
              to:'/tiktokBC'
            }
          ],
          nav: 3,
        }
      },
      {
        path: "/adsManage",
        name: "adsManage",
        component: () => import("@/views/adsManage/index.vue"),
        meta: {
          title: "广告管理",
          requireAuth: true,
        },
      },
      {
        path: "/fbAuthResult",
        name: "fbAuthResult",
        component: () => import("@/views/adsManage/authResult.vue"),
        meta: {
          title: "Facebook授权结果",
          requireAuth: true,
        },
      },
      {
        path: "/fbAdsUpdate",
        name: "fbAdsUpdate",
        component: () => import("@/views/adsManage/update.vue"),
        meta: {
          title: "Facebook广告文案更新",
          requireAuth: true,
        },
      },
      {
        path: "/video-generator-list",
        name: "videoGeneratorList",
        component: () => import("@/views/AITools/VideoGenerator/list.vue"),
        meta: {
          title: "AI素材制作",
          requireAuth: true,
        },
      },
      {
        path: "/video-generator-template",
        name: "videoGeneratorTemplate",
        component: () => import("@/views/AITools/VideoGenerator/templates.vue"),
        meta: {
          title: "AI素材制作-模板",
          requireAuth: true,
        },
      },
      {
        path: "/video-generator-store",
        name: "videoGeneratorStore",
        component: () => import("@/views/AITools/VideoGenerator/store.vue"),
        meta: {
          title: "AI素材制作",
          requireAuth: true,
        },
      }
    ],
  },
];

export default act;
